import { render, staticRenderFns } from "./JenkinsNotification.vue?vue&type=template&id=6aa28d66&"
import script from "./JenkinsNotification.vue?vue&type=script&lang=js&"
export * from "./JenkinsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports